/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer file for authentication
 */

import {
  PO_LIST,
  CMO_MEMBERS_LIST,
  CMO_TYPES_LIST,
  PO_DETAILS,
  PO_STATUS,
  PO_LINE_ITEMS,
  PO_LINE_ITEM_DETAILS,
  MILESTONE_CONFIG_TEMPLATES,
  MILESTONE_CONFIG_TEMPLATE_DATA,
  UPDATE_LINE_STATUS,
  UPDATE_LINE_STATUS_FAIL,
  LINE_ITEM_STATUS_LIST,
  PO_PREVIEW,
  PO_ADD,
  CMO_MEMBERS_WITH_ID,
} from '../../actions/types';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case PO_LIST:
      return {
        ...state,
        poList: action.payload,
      };
    case CMO_MEMBERS_LIST:
      return {
        ...state,
        cmoMembersList: action.payload,
        newPo: false,
        cmoTypesList: false,
      };
    case CMO_TYPES_LIST:
      return {
        ...state,
        cmoTypesList: action.payload,
      };
    case MILESTONE_CONFIG_TEMPLATES:
      return {
        ...state,
        milestoneConfigTemplates: action.payload,
      };
    case MILESTONE_CONFIG_TEMPLATE_DATA:
      return {
        ...state,
        milestoneConfigTemplateData: action.payload,
      };
    case PO_PREVIEW:
      return {
        ...state,
        poPreview: action.payload,
      };
    case PO_ADD:
      return {
        ...state,
        newPo: action.payload,
      };
    case PO_DETAILS:
      return {
        ...state,
        poDetails: action.payload,
        poStatusUpdated: false,
      };
    case PO_STATUS:
      return {
        ...state,
        poStatusUpdated: action.payload,
      };
    case PO_LINE_ITEMS:
      return {
        ...state,
        updatedLineStatus: false,
        poLineItems: action.payload,
      };
    case PO_LINE_ITEM_DETAILS:
      return {
        ...state,
        lineItemDetails: action.payload,
      };
    case UPDATE_LINE_STATUS:
      return {
        ...state,
        updatedLineStatus: true,
        lineItemDetails: {
          ...state.lineItemDetails,
          currentStatus: action.payload,
        },
      };

    case UPDATE_LINE_STATUS_FAIL:
      return {
        ...state,
        updatedLineStatus: false,
        lineUpdateError: action.payload,
      };

    case LINE_ITEM_STATUS_LIST:
      return {
        ...state,
        lineStatusList: action.payload,
      };
    case CMO_MEMBERS_WITH_ID:
      return {
        ...state,
        cmoMemberWithId: action.payload,
      };
    default:
      return state;
  }
}
